import React, {useContext, useState} from 'react';
import {
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Offcanvas,
    OffcanvasBody,
    OffcanvasHeader,
    UncontrolledDropdown
} from "reactstrap";
import logo from "../../../assets/images/logo/logo-white.png";
import {CgClose} from "react-icons/cg";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {ReactSVG} from "react-svg";
import dashboardicon from "../../../assets/images/icons/dashboardicon.svg";
import apiIcon from "../../../assets/images/icons/apiIcon.svg";
import mailIcon from "../../../assets/images/icons/mailIcon.svg";
import Settingicon from "../../../assets/images/icons/Settingicon.svg";
import billingicon from "../../../assets/images/icons/billingIcon.svg";
import logouricon from "../../../assets/images/icons/logouticon.svg";
import ConfirmationModel from "../../ConfirmationModel";
import authContext from "../../../AuthProvider/authContext";
import localized from "../../../i18n";
import {MdLanguage} from "react-icons/md";
import closeIcon from "../../../assets/images/close.svg"
import helpIcon from "../../../assets/images/icons/helpIcon.svg";
import pricingicon from "../../../assets/images/icons/pricingicon.svg";

const selectedLanguage = {
    "en":"English",
    "fr":"French"
}

const MobileSideCanvas = ({isOpen, toggle}) => {
    const {logout, state ,updateAuth} = useContext(authContext);
    const location = useLocation();
    const navigate = useNavigate();
    const [showLogoutModel, setLogoutModel] = useState(false);

    const toggleLogoutModel = () => {
        setLogoutModel(!showLogoutModel);
    }

    const changeLanguage = (event) => {
        updateAuth({lang: event.target.value});
        localStorage.setItem('lang', event.target.value);
        localized.setLanguage(localStorage.getItem('lang'));
    }

    const handleNavigate = (link = "/dashboard") => {
        navigate(link);
        toggle();
    }

    return (
        <Offcanvas
            isOpen={isOpen}
            toggle={toggle}
            className="mobile_sidebar_modal"
        >
            <OffcanvasBody>
                <div className={"close-icon"}>
                   <img src={closeIcon} onClick={toggle} className={"cursor-pointer"}/>
                </div>
                <div className="sidebar-logo">
                    <img src={logo} alt="logo" style={{paddingLeft:"20px"}}/>
                </div>
                <nav className="navbar-main">
                    <ul>
                        <li className={`sidebar-nav-items ${location.pathname === "/dashboard" ? "active" : ""} `}>
                            <div onClick={()=>handleNavigate("/dashboard")} className="sidebar-nav-link">
                                <div className="sidebar-nav-icon">
                                    <ReactSVG src={dashboardicon}/>
                                </div>
                                <div className="sidebar-nav-title">{localized.verify_email}</div>
                            </div>
                        </li>
                        <li className={`sidebar-nav-items ${location.pathname === '/api-documentation' ? "active" : ""} `}>
                            <div onClick={()=>handleNavigate("/api-documentation")} className="sidebar-nav-link">
                                <div className="sidebar-nav-icon">
                                    <ReactSVG src={apiIcon}/>
                                </div>
                                <div className="sidebar-nav-title">{localized.API}</div>
                            </div>
                        </li>

                        <li className={`sidebar-nav-items ${location.pathname === "/settings" ? "active" : ""} `}>
                            <div onClick={()=>handleNavigate("/settings")} className="sidebar-nav-link">
                                <div className="sidebar-nav-icon">
                                    <ReactSVG src={Settingicon}/>
                                </div>
                                <div className="sidebar-nav-title">{localized.Settings}</div>
                            </div>
                        </li>
                        <li className={`sidebar-nav-items ${location.pathname === "/invoices" ? "active" : ""} `}>
                            <div onClick={()=>handleNavigate("/invoices")} className="sidebar-nav-link">
                                <div className="sidebar-nav-icon">
                                    <ReactSVG src={billingicon}/>
                                </div>
                                <div className="sidebar-nav-title">{localized.Billing}</div>
                            </div>
                        </li>
                        <li className={`sidebar-nav-items ${location.pathname === "/pricing-plan" ? "active" : ""} `}>
                            <Link to={"/pricing-plan"} className="sidebar-nav-link">
                                <div className="sidebar-nav-icon">
                                    <ReactSVG src={pricingicon} className={"price-icon"}/>
                                </div>
                                <div className="sidebar-nav-title">{localized.Pricing}</div>
                            </Link>
                        </li>
                    </ul>
                    <ul>
                        <li className="sidebar-nav-items" >
                            <div className={`sidebar-nav-link}`}>
                                <a href="https://verif.email/faq/" target="_blank">
                                    <div className="sidebar-nav-link">
                                        <div className="sidebar-nav-icon">
                                            <ReactSVG src={helpIcon} height="20px"/>
                                        </div>
                                        <div className="sidebar-nav-title">{localized.FAQ}</div>
                                    </div>
                                </a>
                            </div>
                        </li>
                        <li className="sidebar-nav-items" >
                            <div className={`sidebar-nav-link`}>
                                <a href="https://verif.email/contact/" target="_blank">
                                    <div className="sidebar-nav-link">
                                        <div className="sidebar-nav-icon">
                                            <ReactSVG src={mailIcon}/>
                                        </div>
                                        <div className="sidebar-nav-title">{localized.Support}</div>
                                    </div>
                                </a>
                            </div>
                        </li>
                        <li className="sidebar-nav-items active" onClick={toggleLogoutModel}>
                            <div className="sidebar-nav-link ">
                                <div className="sidebar-nav-icon">
                                    <ReactSVG src={logouricon} className="logout-icon"/>
                                </div>
                                <div className="sidebar-nav-title">{localized.Logout}</div>
                            </div>
                        </li>
                    </ul>
                </nav>
            </OffcanvasBody>
            <ConfirmationModel
                title={localized.are_you_sure_want_to_logout}
                isOpen={showLogoutModel}
                disabled={state.isSubmitting}
                submitBtn={localized.Logout}
                className={"logout-modal"}
                onClose={toggleLogoutModel}
                onSubmit={() => logout(true)}
            />
        </Offcanvas>
    );
};

export default MobileSideCanvas;